<template>
  <div class="box">
    <h2 class="proTitleStyle">提示</h2>
    <div class="textBox">
      <p class="textStyle">
        是否已足额缴存担保金到还款账户
      </p>
      <p class="textStyle">{{ repay_acct_no || '' }}？</p>
    </div>
    <div class="footerBotton">
      <FooterTwoButton
        :leftNext="leftNext"
        :rightNext="rightNext"
        right="未缴存"
        left="已缴存"
      ></FooterTwoButton>
    </div>
  </div>
</template>
<script>
import FooterTwoButton from '@/components/FooterTwoButton.vue';

export default {
  name: 'InstructionsInfo',
  data() {
    return {};
  },
  props: ['leftNext', 'rightNext', 'repay_acct_no'],
  components: {
    FooterTwoButton,
  },
};
</script>
<style scoped>
.proTitleStyle {
  margin: 0;
  padding: 14px;
  font-size: 16px;
  text-align: left;
  color: #1c2438;
  border-bottom: 1px solid #e9f0f5;
  margin-bottom: 12px;
}
.textBox {
  margin: 0;
  padding: 30px 16px;
}
.textStyle {
  margin: 0;
  color: #1c2438;
  font-size: 14px;
  text-align: center;
}
.footerBotton {
  margin-bottom: 42px;
}
</style>
